import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ContextMenuInterface } from '../model';

@Injectable({
  providedIn: 'root',
})
export class ContextMenuEditorService {
  contextMenuClose = new EventEmitter<any>();
  _eventDetails = new BehaviorSubject<any>('');

  getEventDetails() {
    return this._eventDetails.asObservable();
  }

  setEventDetails(data: any) {
    this._eventDetails.next(data);
  }

  public removeElementsByName(array, namesToRemove): ContextMenuInterface[] {
    return array.filter((item) => !namesToRemove.includes(item.name));
  }
}
